module.exports = __webpack_public_path__ + "static/img/zip.254fb555.svg";